import ga from "../shared/analytics";
import Input from "./input";
import React, { Component } from "react";
import request from "superagent";
import ReCAPTCHA from "react-google-recaptcha";
import ContactFormDisclaimer from "./contact-form-disclaimer";
import DropdownSelect from "../shared/dropdown-select/dropdown-select";
import { INAPPROPRITATEWORDS } from "../../constants/constants";

const inputs = [
  {
    type: "text",
    name: "firstName",
    placeholder: "First Name*",
    required: true,
    autoComplete: "given-name",
  },
  {
    type: "text",
    name: "lastName",
    placeholder: "Last Name*",
    required: true,
    autoComplete: "family-name",
  },
  { type: "number", name: "phone", placeholder: "Phone", autoComplete: "tel" },
  {
    type: "email",
    name: "email",
    placeholder: "Email*",
    required: true,
    autoComplete: "email",
  },
];

const defaults = {
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  message: "",
  reason: "interested in selling",
};

const reasonOptions = [
  { label: `I'm interested in selling`, value: "interested in selling" },
  { label: `I'm interested in renting`, value: "interested in renting" },
  { label: `I'm interested in buying`, value: "interested in buying" },
  { label: `Other`, value: "other" },
];

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: defaults, //TODO add agent info
      inputs: inputs,
      success: false,
      errorMessage: null,
      recaptcha: false,
    };
  }

  onCaptchaChange = () => {
    this.setState({ recaptcha: true });
  };

  onCaptchaExpire = () => {
    this.setState({ recaptcha: false });
  };

  onChange = (e) => {
    let data = { ...this.state.data };
    let inputData = this.state.inputs;
    data[e.target.name] = e.target.value;
    this.setState({ data: data, inputs: inputData });
  };

  handleDropdownChange = (option, id) => {
    let data = { ...this.state.data };
    data[id] = option.value;
    this.setState({ data: data });
  };

  submit = (e) => {
    e.preventDefault();
    const data = { ...this.state.data, toEmail: this.props.emailAddress };
    if (this.validateEnteredContent(data)) {
      ga.event("Agent-Interaction", "Inquiry", data.reason);
      request
        .post("/api/inquire")
        .set("Content-Type", "application/json")
        .send(data)
        .end((error, response) => {
          if (error) {
            console.error(error);
            this.setState({
              errorMessage: error.response && error.response.text,
            });
          } else {
            if (response.body.success) {
              this.cleanForm();
              this.setState({ success: true, errorMessage: null });
            }
          }
        });
    } else {
      this.setState({
        errorMessage:
          "You have entered an inappropiate content on the Contact form, Please correct the entered content",
      });
    }
  };

  cleanForm = () => {
    this.setState({ data: defaults });
  };

  validateEnteredContent = (datatoCheck) => {
    let found = false;
    for (const [key, value] of Object.entries(datatoCheck)) {
      const updated = value.replace(/[^a-zA-Z0-9]/g, " ").split(" ");
      const isSlur = updated.some((i) => {
        return INAPPROPRITATEWORDS.some((w) => w === i.trim().toLowerCase());
      });
      if (isSlur) {
        found = true;
        break;
      }
    }

    if (
      found ||
      datatoCheck.email.toLowerCase() === "dc319171@gmail.com"
    ) {
      return false;
    } else {
      return true;
    }
  };

  render() {
    const { recaptcha } = this.state;
    let successMessage,
      errorMessage = null;
    if (this.state.success) {
      successMessage = (
        <span
          className="alert alert-success"
          style={{ display: "inline-block" }}
        >
          Your request has been submitted!
        </span>
      );
    }
    if (this.state.errorMessage) {
      errorMessage = (
        <span
          className="alert alert-danger"
          style={{ display: "inline-block" }}
        >
          {this.state.errorMessage}
        </span>
      );
    }
    return (
      <div>
        <div style={{ color: "#555555", marginBottom: "10px" }}>
          "*" indicates a required field
        </div>
        <form onSubmit={this.submit}>
          {this.state.inputs.map((data, i) => (
            <Input
              data={data}
              onChange={this.onChange}
              key={i}
              value={this.state.data[data.name]}
            />
          ))}
          <div className="form-group col-xs-16">
            <DropdownSelect
              label="Reason"
              id="reason"
              options={reasonOptions}
              handleChange={this.handleDropdownChange}
              selected={this.state.data.reason}
            />
          </div>
          <div className="form-group col-xs-16">
            <label className="control-label floating-label" htmlFor="message">
              Message
            </label>
            <textarea
              onChange={this.onChange}
              className="form-control"
              type="text"
              name="message"
              value={this.state.data.message}
            />
          </div>
          <div className="form-group col-xs-16">
            <ReCAPTCHA
              ref="recaptcha"
              sitekey="6LcK4cUUAAAAAAp5zw1npy6EK0UCunWq5_YMgynC"
              onChange={this.onCaptchaChange}
              onExpired={this.onCaptchaExpire}
            />
          </div>

          <div className="submit-button">
            {errorMessage}
            {successMessage}

            <button
              style={{ display: recaptcha ? "block" : "none" }}
              type="submit"
              className="aw-button"
            >
              Send
            </button>
          </div>

          <ContactFormDisclaimer buttonText="Send" />
        </form>
      </div>
    );
  }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/contact/contact-form.js